import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
import { LOCAL_STORAGE } from "../../utils/constant";
import Axios from "axios";

const MyContainerSize = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [containerSizeList, setContainerSizeList] = useState([])

    useEffect(() => {
        let token = LOCAL_STORAGE.userToken
        let userId = LOCAL_STORAGE.userId
        let customerNo = LOCAL_STORAGE.customerNo

        Axios.get(
            `${process.env.REACT_APP_MASTER_API}/container_size?customerNumber=${customerNo}&userId=${userId}`,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }
        )
            .then((response) => {
                let containerData = response.data.resultSet;
                setContainerSizeList(
                    containerData.map((item, index) => {
                        return {
                            key: index + 1,
                            text: item.containerSize,
                            name: item.containerSizeCode,
                            value: item.containerSizeCode,
                            raw: { ...item },
                        };
                    })
                );
            })
            .catch((error) => console.log(error));
    }, [])

    return (
        <Dropdown
            selection
            clearable
            // loading={isloading}
            style={{ width: "100%" }}
            // search
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={containerSizeList}
            {...props}
        />

    )
}

export default MyContainerSize